module.exports = __webpack_public_path__ + "media/components/assets/images/sseobolgga/image8_3_sub1-f1a210bb513428644d037b5a69a7e6c3.png";